// extracted by mini-css-extract-plugin
export default {"wrapper":"Layout_wrapper__2dOTA","paddingBig":"Layout_paddingBig__236mP","paddingSmall":"Layout_paddingSmall__30Wxp"};